<div class="confirm-dialog">

        <mat-icon id="close-icon"  (click)=closeDialog()>close</mat-icon>
        <p id="content-message">{{data.message}}</p>
  
    <div class="buttons">
        <button class="btn btn-outline-danger" id="no-button" [mat-dialog-close]="false">NON</button>
        <button class="btn btn-outline-primary" id="yes-button" [mat-dialog-close]="true">OUI</button>
    </div>
  
</div>